<template>
  <div v-if="!isMobile" class="header">
    <div class="header__content">
      <a href="https://makclife.ru/" class="header__logo">
        <img src="@/profile/assets/icons/logo.svg" alt="logo" class="header__logo-pic">
      </a>
      <div class="header__nav">
        <div v-for="(el, elIndex) in headerNav" :key="elIndex" @click="routeChange(el.link)" class="header__nav-item">
          <span class="header__nav-link">{{ el.text }}</span>
        </div>
        <div v-for="(el, elIndex) in menu" :key="elIndex" @click="routeChange(el.path)" class="header__nav-item">
          <span class="header__nav-link">{{ el.name }}</span>
        </div>
      </div>
      <div class="header__right" v-if="!auth">
        <span class="header__right-link" @click="logoutHandle()">
          Выход
        </span>
      </div>
    </div>
  </div>
  <div v-else class="header_mobile">
    <div class="header__content_mobile">
      <a href="https://makclife.ru/">
        <img src="@/profile/assets/icons/logo-mobile.svg" alt="logo">
      </a>
      <img
        v-if="!mobileMenuIsOpened" @click="mobileMenuHandleFunc()"
        src="@/profile/assets/icons/menu-mobile.svg" alt="menu" class="header__menu-pic_mobile">
      <img
        v-else @click="mobileMenuHandleFunc()"
        src="@/profile/assets/icons/menu-mobile_opened.svg" alt="menu" class="header__menu-pic_mobile">
    </div>
  </div>
</template>

<script>
import { headerNav } from "@/profile/components/layout/navigation.js";

export default {
  name: "MainHeader",
  props: {
    auth: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    mobileMenuIsOpened: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      headerNav: headerNav,
    };
  },
  methods: {
    logoutHandle() {
      this.$emit("logout");
    },
    mobileMenuHandleFunc() {
      this.$emit("mobileMenuHandle");
    },
    routeChange(arg) {
      this.$router.push({ name: `${arg}`});
    }
  },
};

</script>

<style lang="scss">

</style>
